import { format, fromUnixTime, isToday, isYesterday } from "date-fns";

interface ActivityDateHeaderProps {
  /** Unix timestamp (seconds) for the date to display */
  date: number;
}

/**
 * Day separation header for the activity feed. Displays the date in a pill/badge
 * style for clear visual separation between days.
 */
export function ActivityDateHeader({ date }: ActivityDateHeaderProps) {
  const dateObj = fromUnixTime(date);
  const formatted = isToday(dateObj)
    ? "Today"
    : isYesterday(dateObj)
      ? "Yesterday"
      : format(dateObj, "EEEE, MMMM d");

  return (
    <li className="flex items-center gap-3 py-3">
      <div className="h-px flex-1 bg-persian-100" aria-hidden />
      <span className="inline-flex items-center rounded-full bg-persian-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-persian-800">
        {formatted}
      </span>
      <div className="h-px flex-1 bg-persian-100" aria-hidden />
    </li>
  );
}
